import React, { useEffect, useRef } from 'react';
import './BookingModal.css';
import { formatCurrency } from '../../utils/pricing';

const BookingModal = ({ open, onClose, booking = {} }) => {
  if (!open) return null;

  const modalRef = useRef(null);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    // focus the modal for accessibility
    setTimeout(() => modalRef.current && modalRef.current.focus(), 0);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  const handleConfirm = () => {
    // Simulate booking success (no backend)
    // In a real app we'd POST booking to an API here
    alert(`Réservation simulée pour ${booking.destination.name} - ${booking.days} jour(s) - ${booking.transport.name} - ${formatCurrency(booking.price)}`);
    onClose();
  };

  return (
    <div className="bm-overlay" role="dialog" aria-modal="true">
      <div className="bm-modal" ref={modalRef} tabIndex={-1}>
        <header className="bm-header">
          <h3>Récapitulatif de la réservation</h3>
          <button className="bm-close" onClick={onClose} aria-label="Fermer">✕</button>
        </header>

        <div className="bm-body">
          <p><strong>Destination:</strong> {booking.destination.name}</p>
          <p><strong>Durée:</strong> {booking.days} jour(s)</p>
          <p><strong>Transport:</strong> {booking.transport.name}</p>
          <p><strong>Prix estimé:</strong> {formatCurrency(booking.price)}</p>
        </div>

        <footer className="bm-footer">
          <button className="btn btn-secondary" onClick={onClose}>Annuler</button>
          <button className="btn btn-primary" onClick={handleConfirm}>Confirmer (simulé)</button>
        </footer>
      </div>
    </div>
  );
};

export default BookingModal;
